import { createApp } from "vue";
import "./style.scss";
import "bootstrap";
import App from "./App.vue";

createApp(App).mount("#app");
